<template>
  <client-page>
    <div class="sub-visual sub-visual--sv5">
      <v-container>
        <h2 class="sub-visual__title"><span>PRICING</span></h2>
      </v-container>
    </div>
    <PriceList></PriceList>
  </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import PriceList from '@/components/client/en/price/productList.vue'

export default {
    components: {
        ClientPage,
        PriceList
    },
};
</script>